import axios from "axios";
import { AccountType } from "shared/types/accounts";

interface otherAccountProps {
  login: string;
  profilePictureUrl: string;
  platformTypeOther?: string;
  platformType?: string;
}

export async function connectOtherAccount({
  login,
  profilePictureUrl,
  platformTypeOther,
}: otherAccountProps): Promise<AccountType> {
  const isTT = platformTypeOther?.toLocaleLowerCase() === "tiktok";
  const dataToSend: otherAccountProps = {
    login,
    profilePictureUrl,
    platformType: isTT ? "TT" : "OT",
  };

  if (!isTT) {
    dataToSend.platformTypeOther = platformTypeOther;
  }

  const {
    data: { data },
  } = await axios.post("/accounts/ot", dataToSend);
  return data;
}
